<template>
  <div>
    <heard />
    <el-upload
      class="upload"
      action
      :accept="'.m4a, .wav, .mp3'"
      :on-change="handleChange"
      :show-file-list="false"
      :auto-upload="false"
    >
      <el-button type="primary" :size="'small'">上传文件</el-button>
    </el-upload>

    <div class="wrapper">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="fileOriginal"
          label="音频名称"
          width="180"
        ></el-table-column>
        <el-table-column prop="fileStatus" label="状态"> </el-table-column>
        <el-table-column prop="fileList" label="文件列表">
          <template slot-scope="scope">
            <el-link
              :disabled="scope.row.fileStatus != '已完成'"
              style="margin-right: 10px"
              @click="downLoadEAF(scope.row)"
              type="success"
              >EAF</el-link
            >
            <el-link
            :disabled="scope.row.fileStatus != '已完成'"
              style="margin-right: 10px"
              @click="downLoadTxt(scope.row)"
              type="success"
              >文本特征</el-link
            >
            <el-link
            :disabled="scope.row.fileStatus != '已完成'"
              style="margin-right: 10px"
              @click="downLoadJson(scope.row)"
              type="success"
              >JSON</el-link
            >
            <el-link
            :disabled="scope.row.fileStatus != '已完成'"
              style="margin-right: 10px"
              @click="downLoadVidep(scope.row)"
              type="success"
              >音频</el-link
            >
          </template>
        </el-table-column>
        <el-table-column prop="uploadDate" label="上传时间"> </el-table-column>
        <el-table-column prop="downLoad" label="操作" width="180">
          <el-button  slot-scope="scope" size="mini" type="primary" @click="downZip(scope.row)" :disabled="scope.row.fileStatus != '已完成'">打包下载</el-button>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          class="opc_pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 30, 50, 70]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFileV2, getAnalysisRecord } from "@/utils/custom.js";
import heard from "../components/heard.vue";
import { mapState } from "vuex";
export default {
  components: {
    heard,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      file: "",
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    handleSizeChange: function (size) {
      this.pageSize = size;
      this.getlist();
    },
    handleCurrentChange: function (currentPage) {
      this.pageNum = currentPage;
      this.getlist();
    },
    getlist() {
      const params = {
        userId: this.userInfo.userId,
      };
      getAnalysisRecord(this.pageNum, this.pageSize, params).then((res) => {
        this.tableData = res.rows;
        this.total = res.total * 1;
      });
    },
    downLoadEAF(data) {
      let link = data.fileUrl.replace(".wav", ".eaf").replace(".m4a", ".eaf").replace(".mp4", ".eaf").replace(".mp3", ".eaf");
      window.open(link, "_blank");
    },
    downLoadJson(data) {
      let link = data.fileUrl.replace(".wav", ".json").replace(".m4a", ".json").replace(".mp4", ".json").replace(".mp3", ".json");
      window.open(link, "_blank");
    },
    downLoadTxt(data) {
      let link = data.fileUrl.replace(".wav", ".txt").replace(".m4a", ".txt").replace(".mp4", ".txt").replace(".mp3", ".txt");
      window.open(link, "_blank");
    },
    downLoadVidep(data) {
      let link = data.fileUrl;
      window.open(link, "_blank");
    },
    downZip(data){
      console.log(data,'data')
      let link = data.fileUrl.replace(".wav", ".zip").replace(".m4a", ".zip").replace(".mp4", ".zip").replace(".mp3", ".zip");
      window.open(link, "_blank");
    },
    handleChange(file) {
      this.file = file.raw;
      let fd = new FormData();
      fd.append("file", this.file);
      fd.append("userId", this.userInfo.userId);
      uploadFileV2(fd).then((res) => {
        this.getlist();
        this.$message.success("上传成功");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 25px;
}
.upload {
  margin: 25px;
  margin-bottom: 0;
}
.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>
